import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof this.props?.onError === "function") {
      this.props.onError(error, errorInfo);
    }
    // Keep console error for debugging in dev.
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{ padding: 24 }}>
          <h2 style={{ marginBottom: 8 }}>Something went wrong.</h2>
          <div>Please refresh the page and try again.</div>
        </div>
      );
    }
    return this.props.children;
  }
}

